<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>

    <navbar v-if="showNavbar" :title="$t('global.batixsoftware')"></navbar>

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="
                  $t('dashboard.educationcourse') +
                  (lehrgang.bezeichnung ? ': ' + lehrgang.bezeichnung : '')
                "
              ></head-menu>

              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />{{
                      $t("global.tolist")
                    }}
                  </button>

                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t("global.save") }}
                  </button>

                  <button
                    v-if="editable"
                    class="btn btn-primary mr-2"
                    @click="semesterKopierenModal"
                    :disabled="invalid"
                  >
                    <font-awesome-icon icon="fa-duotone fa-gem" class="mr-2" />
                    {{ $t("global.semesterfromtemplate") }}
                  </button>

                  <button
                    v-if="editable"
                    class="btn btn-primary mr-2"
                    @click="endnotenBerechnen"
                    :disabled="invalid"
                  >
                    {{ $t("global.calculatefinalgrades") }}
                  </button>

                  <button
                    v-if="editable && lehrgang.startperiode == 4"
                    class="btn btn-primary mr-2"
                    @click="showNotenausweisPdfModal"
                    :disabled="invalid"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-print"
                      class="mr-2"
                    />
                    <em>{{ $t("global.printperformancerecords") }}</em>
                  </button>

                  <button
                    v-if="editable && lehrgang.startperiode != 4"
                    class="btn btn-primary mr-2"
                    @click="showNotenausweisPdfModal"
                    :disabled="invalid"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-print"
                      class="mr-2"
                    />
                    <em>{{ $t("global.printprediplomacertificates") }}</em>
                  </button>

                  <button
                    class="btn btn-primary mr-2"
                    @click="Endnotenuebersicht"
                  >
                    {{ $t("global.finalgradeoverview") }}
                  </button>

                  <button
                    class="btn btn-primary mr-2"
                    @click="kompetenzRaster"
                    v-if="lehrgang && lehrgang.kompetenzraster"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-ballot-check"
                      class="mr-2"
                    />{{ $t("global.competencegrid") }}
                  </button>

                  <!-- Notenuebersicht
                  <router-link
                    class="btn btn-primary mr-2"
                    :to="{
                      name: 'Notenuebersicht',
                      params: {
                        id: id,
                        anzeige: 0,
                      },
                    }"
                  >
                    <font-awesome-icon icon="fa-regular fa-plus" />
                    Neue Notenübersicht
                  </router-link>
                   -->
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.b_bildung_bildungsgang.delete"
                  >
                    <font-awesome-icon
                      class="mr-1"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <bildungsgang-stammdaten
            :lehrgang="lehrgang"
            :editable="editable"
            :isTemplate="false"
          />
        </div>

        <div class="col-xl-12 p-0" :class="{ 'col-xl-12': !showNavbar }">
          <vorlage-promotionsstruktur
            :isBusy="isBusy"
            :ladeFehler="ladeFehler"
            :klassen="klassen"
            :lehrgang="lehrgang"
            :notentypen="notentypen"
            @psChanged="setPromotionsstruktur"
            @enChanged="setEndnotenstruktur"
          />
        </div>

        <div v-if="lehrgangid" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 p-0">
              <ul class="nav nav-tabs mt-3 fs-28">
                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 0 }"
                    :to="{
                      name: 'bildungsgang',
                      params: { lehrgangid: lehrgangid, anzeige: 0 },
                    }"
                    >{{ $t("global.assignment") }}</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="col-xl-12 p-0">
              <div class="tab-container p-3">
                <div v-show="anzeige === 0">
                  <!-- Start Zuordnung -->
                  <klassenliste
                    :lehrgang="lehrgang"
                    :shown="anzeige == 0 ? true : false"
                    :editable="editable"
                    @ladeKlassen="ladeKlassen"
                    @klasseLoaded="setKlassen"
                  />
                  <!-- Ende Zuordnung -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal
      id="bildungsgang-loeschen-modal"
      @confirmed="bildungsgangloeschen"
    />

    <Kompetenzraster-modal />

    <message-box
      id="semester-kopieren-modal"
      :headerText="$t('global.copysemester')"
      :text="$t('global.doyoucopyallorjustnextsemester')"
      :ok="true"
      :cancel="true"
      :repeat="true"
      :okText="$t('global.thenext')"
      :repeatText="$t('global.allavailable')"
      :cancelText="$t('global.cancel')"
      @ok="createBildungsgangNext"
      @repeat="createBildungsgangAll"
    />

    <notenausweis-pdf-modal
      id="notenausweis-pdf-modal"
      :leistungsausweisAusgeben="leistungsausweisAusgeben"
      :vordiplomausweisAusgeben="vordiplomausweisAusgeben"
      :date="date"
      :lehrgangid="lehrgangid"
      :showLeistungsausweis="lehrgang.startperiode == 4"
      :showVordiplomausweis="lehrgang.startperiode != 4"
      @dateChanged="updateDate"
    >
    </notenausweis-pdf-modal>

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <change-watcher-alert />
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";

import Api from "@/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import server from "@/server";

import page from "@/mixins/Page";
import ChangeWatcher from "@/mixins/ChangeWatcher";

import BildungsgangStammdaten from "@/components/Bildung/Bildungsgang/Stammdaten";
import VorlagePromotionsstruktur from "@/components/Bildung/Bildungsgang/VorlagePromotionsstruktur";
import Klassenliste from "@/components/Reiter/Klassenliste";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import MessageBox from "@/components/Modals/Messagebox";
import NotenausweisPdfModal from "@/components/Modals/NotenausweisPDFModal";
import KompetenzrasterModal from "@/components/Bildung/Kompetenzraster/KompetenzrasterModal.vue";

import { textNotLinked } from "@/defaultTexts.js";

export default {
  name: "Bildungsgang",
  components: {
    Klassenliste,
    HeadMenu,
    Navbar,
    BildungsgangStammdaten,
    LoeschenModal,
    MessageBox,
    VorlagePromotionsstruktur,
    NotenausweisPdfModal,
    KompetenzrasterModal,
  },

  metaInfo() {},
  mixins: [page, ChangeWatcher],
  props: {
    lehrgangid: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
    /*
    notenuebersichtid: {
      type: String,
      default: "7",
    },*/
  },
  data() {
    return {
      isBusy: false,
      ladeFehler: false,
      lehrgang: {
        lehrgangstatus: null,
        lehrgangleiter: { personName: textNotLinked },
        templatelehrgang: { bezeichnung: textNotLinked },
      },

      BildungsgangStartenModalId: "modal-bildungsgang-starten",
      klassen: [],
      date: new Intl.DateTimeFormat("ch-DE").format(new Date()),
      leistungsausweis: [],
      vordiplomausweis: [],
      pdfPath: "",
    };
  },
  computed: {
    notentypen: {
      get() {
        return this.$store.state.veranstaltung.notentypen;
      },
    },
  },
  watch: {},
  created() {
    if (this.lehrgangid) {
      this.loading = true;

      Api.get("lehrgaenge/", { params: { id: this.lehrgangid } })
        .then((response) => {
          this.initializeBildungsgang(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    } else this.editable = true;
  },
  mounted: function () {},
  methods: {
    showNotenausweisPdfModal() {
      this.$bus.$emit("open-modal", "notenausweis-pdf-modal");
    },

    leistungsausweisAusgeben() {
      Api.get("notenberechnung/endnoten/", {
        params: { lehrgangid: this.lehrgangid },
      })
        .then((response) => {
          this.leistungsausweis = response.data;
          if (this.leistungsausweis?.length > 0) {
            let filename = new Intl.DateTimeFormat("ch").format(new Date());
            this.pdfPath =
              server.url +
              `/pdfgenerator/pdf.act?filename=Leistungsausweis${filename}.pdf&report=/pdfgenerator/leistungsausweis.htm&ids=${this.lehrgangid}&date=${this.date}`;
            this.$refs.pdfLayer.show();
          } else {
            this.$notify({
              type: "error",
              title: this.$t("notification.actionfailed"),
              duration: 5000,
              text: this.$t(
                "notification.nodataavailableaddgradetoclassassigningradetoolcalculate"
              ),
            });
          }
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: this.$t("notification.actionfailed"),
            duration: 5000,
            text: this.$t(
              "notification.nodataavailableaddgradetoclassassigningradetoolcalculate"
            ),
          });
        });
    },
    vordiplomausweisAusgeben() {
      Api.get("notenberechnung/endnoten/", {
        params: { lehrgangid: this.lehrgangid },
      })
        .then((response) => {
          this.vordiplomausweis = response.data;
          if (this.vordiplomausweis?.length > 0) {
            let filename = new Intl.DateTimeFormat("ch").format(new Date());
            this.pdfPath =
              server.url +
              `/pdfgenerator/pdf.act?filename=Vordiplomausweis${filename}.pdf&report=/pdfgenerator/vordiplomausweis.htm&ids=${this.lehrgangid}&date=${this.date}`;
            this.$refs.pdfLayer.show();
          } else {
            this.$notify({
              type: "error",
              title: this.$t("notification.actionfailed"),
              duration: 5000,
              text: this.$t(
                "notification.nodataavailableaddgradetoclassassigningradetoolcalculate"
              ),
            });
          }
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: this.$t("notification.actionfailed"),
            duration: 5000,
            text: this.$t(
              "notification.nodataavailableaddgradetoclassassigningradetoolcalculate"
            ),
          });
        });
    },
    updateDate(selectedDate) {
      this.date = selectedDate;
    },
    abbrechen() {
      this.$router.push({ name: "bildungsgang-liste" });
    },

    initializeBildungsgang(lehrgang) {
      if (lehrgang) {
        this.lehrgang = lehrgang;

        if (!this.lehrgang.lehrgangleiter)
          this.lehrgang.lehrgangleiter = { personName: textNotLinked };

        if (!this.lehrgang.lehrgangstatus)
          this.lehrgang.lehrgangstatus = { personName: textNotLinked };

        this.editable =
          this.lehrgang.lehrgangstatus.id ==
          this.$CONST("LEHRGANGSTATI").PLANNED
            ? true
            : true;
      } else this.editable = true;

      this.editable = this.berechtigungen.b_bildung_bildungsgang.update;

      //this.initChangeWatcher(this.lehrgang);
    },
    setPromotionsstruktur(val) {
      this.lehrgang.promotionsstruktur = val;
    },

    setEndnotenstruktur(val) {
      this.lehrgang.endnotenstruktur = val;
    },

    ladeKlassen(ladeFehler) {
      if (ladeFehler) {
        this.ladeFehler = true;
      } else {
        this.isBusy = true;
      }
    },

    setKlassen(val) {
      this.klassen = val;
      this.isBusy = false;
    },

    speichern() {
      if (this.loading) return;

      this.loading = true;

      var json = Object.assign({}, this.lehrgang);

      // Relationen auf ID reduzieren

      json.lehrgangstatus = this.lehrgang.lehrgangstatus
        ? this.lehrgang.lehrgangstatus.id
        : this.$CONST("LEHRGANGSTATI").PLANNED;

      json.lehrgangleiter = this.lehrgang.lehrgangleiter.id;

      // Defaultwerte

      json.veranstaltungstyp = this.$CONST("VERANSTALTUNGSTYPEN").STUDIES;

      if (!this.lehrgangid) {
        Api.post("lehrgaenge/", json)
          .then((response) => {
            this.initializeBildungsgang(response.data);
            this.$notify({
              type: "success",
              title: this.$t("notification.actionsuccessful"),
              text: this.$t("notification.educationcoursesuccessfullysaved"),
            });

            this.$router.replace({
              name: "bildungsgang",
              params: { lehrgangid: response.data.id, anzeige: 0 },
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        Api.put("lehrgaenge/", json, { params: { id: this.lehrgang.id } })
          .then((response) => {
            this.initializeBildungsgang(response.data);
            this.$notify({
              type: "success",
              title: this.$t("notification.actionsuccessful"),
              text: this.$t("notification.educationcoursesuccessfullysaved"),
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "bildungsgang-loeschen-modal");
    },

    bildungsgangloeschen() {
      Api.delete("lehrgaenge/", {
        params: { ids: this.lehrgangid },
      }).then(() => {
        this.$router.push({ name: "bildungsgang-liste" });
      });
    },

    semesterKopierenModal() {
      this.$bus.$emit("open-modal", "semester-kopieren-modal");
    },
    createBildungsgangNext() {
      console.log("Methode aufgerufen", this.lehrgangid);
      if (!this.lehrgangid) {
        this.$notify({
          type: "warning",
          title: this.$t("notification.actionfailed"),
          text: this.$t("notification.educationcoursenotsaved"),
        });
      } else {
        Api.post(
          "template/klassevontemplate/?id=" + this.lehrgangid + "&all=false"
        ).then(() => {
          this.$bus.$emit("update-klassen-liste");
        });
      }
    },
    createBildungsgangAll() {
      if (!this.lehrgangid) {
        this.$notify({
          type: "warning",
          title: this.$t("notification.actionfailed"),
          text: this.$t("notification.educationcoursenotyetsaved"),
        });
      } else {
        Api.post(
          "template/klassevontemplate/?id=" + this.lehrgangid + "&all=true"
        ).then(() => {
          this.$bus.$emit("update-klassen-liste");
        });
      }
    },
    endnotenBerechnen() {
      if (this.loading) return;

      this.loading = true;

      Api.post(
        "notenberechnung/endnoten/",
        {},
        {
          params: { lehrgangid: this.lehrgangid },
        }
      )
        .then((response) => {
          console.log(response);

          this.$notify({
            type: "success",
            title: this.$t("notification.actionsuccessful"),
            text: this.$t("notification.gradecalculationperformed"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    Endnotenuebersicht() {
      this.$router.push({
        name: "Endnotenuebersicht",
        params: {
          lehrgangid: this.lehrgangid,
        },
      });
    },

    kompetenzRaster() {
      this.$bus.$emit(
        "kompetenzraster-modal-show",
        this.lehrgang.kompetenzraster.id
      );
    },
  },
};
</script>

<style>
</style>
